// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"672":"3c0605c7","790":"9fc6fa2d","931":"5451b8c1"}[chunkId] + ".js";
};